export default "__VITE_ASSET__CfI$oFgQ__"